<template>
<div id="app" v-loading.fullscreen.lock="!$teras.app.ready" :class="'device-'+$teras.app.device">
   <div class="app-main row">
      <div id="main" class="col s12 yo-text-center" >
         <router-view name="main"  v-if="$teras.browser.name!='ie'"></router-view>
         <div style="padding:32px;" v-else>Internet Explorer non è supportato vi preghiamo di utilizzare un browser differente. </div>
      </div><!-- end main -->
   </div><!-- end container -->
</div> <!-- end app -->
</template>

<script>
export default {
   name: 'app'
}
</script>
